import styled from "styled-components";

export const Wrapper = styled.div`
  text-align: center;
  margin: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.05);
  padding-top: 49vh;
`;
